import { Component, OnInit, Input, OnChanges, ViewChild, SimpleChange, EventEmitter, ElementRef, Output, HostListener, ChangeDetectorRef, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { IMessage, IMessageFrom, IdOptions, IdOptionsEnum, IWelcomeMessage, IPayloadToWatson, GlobalStateEnum } from './interfaces'
import { MessageComponent } from './message/message.component';
import { ChatbotHttpClientService, LoginOptions } from './chatbot-http-client.service'
import { LivechatHttpClientService } from './livechat-http-client.service'
import { ChatStateMachine } from './fsm-service.service'
import { Logger } from './chatbot-logger.service'
import { MessageBus } from './service-bus.service'
import * as moment from 'moment';

//https://medium.com/swlh/getting-started-with-howler-js-in-react-67d3a348854b
import { Howl, Howler } from 'howler';
//dela se v App component import { ReactiveFormsModule } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { Observable, timer, interval, Subscription, from, pipe } from 'rxjs';
import { take } from 'rxjs/operators';
import { MatTooltipModule } from '@angular/material/tooltip'
import { ChatMachineStatesEnum, ChatAvailabilityStateEnum, ChatMachineEventEnum, SourceIdEnumSLA, BrowserTypeEnumSLA, QueueAnswerEnumSLA } from './interfaces-livechat';
//import * as zenscroll from 'zenscroll'
let updateTimer = timer(100)
let scrollingTimer = timer(200)

const version = '2.6.6'


@Component({
  selector: 'unitx-chatbot',
  templateUrl: './unitx-angular-chatbot-component.component.html',
  styleUrls: ['./unitx-angular-chatbot-component.component.css'],
})

export class UnitxAngularChatbotComponentComponent implements OnInit, OnChanges {
  private apiClient: ChatbotHttpClientService;

  @ViewChild('unitxChatbotContainerMessages') container: ElementRef;

  /**
     * CHECKLIST PRO DEPLOY ------------------ POZOR !!!!
     * 
     * ZVYSENI VERZE
     * 
     * KC WORKING HOURS 8-22
     * DATUM PRO AKTIVACI KC 12.3
     * DEBUG FALSE
     * INTERVALY VE FSM
     */
  isDebug: boolean = false

  LV_ACTIVE_DATE: string = '2021-03-12'
  //Default prod debug OFF


  WA_ERROR_TEXT: string = `Omlouváme se, ale chatbot není v současné době dostupný. Intenzivně pracujeme na jeho zprovoznění.`
  WA_ERROR_FIXED_TEXT: string = `Chatbot je opět dostupný. Rádi zodpovíme Vaše dotazy.`
  WA_ERROR_NOT_FIXED_TEXT: string = `Chatbot je stále nedostupný.`
  LV_OP_BACK_TO_AVAILABLE_CHAT_MSG: string = `Je nadále možná komunikace s chatbotem.`

  WA_NOT_UNDERSTAND_TEXT: string = "Bohužel si nejsem jistý, zda přesně rozumím. Zkuste se prosím zeptat jiným způsobem.<br/>Zkuste třeba zjednodušit dotaz na samotné klíčové slovo."
  WA_NOT_UNDERSTAND_TEXT_AFTER_12_3: string = "Bohužel si nejsem jistý, zda přesně rozumím. Zkuste se prosím zeptat jiným způsobem.<br/>Zkuste třeba zjednodušit dotaz na samotné klíčové slovo."

  WA_WELCOME_MESSAGE: string = `Dobrý den, vítá Vás náš chatbot, rádi zodpovíme Vaše dotazy.`

  WA_INTRO_MSG: string = 'Ptejte se, prosím.'
  WA_BY_MSG: string = 'Rádo se stalo. Neváhejte se kdykoli zeptat znovu.'

  WA_MAX_INPUT: number = 200
  LV_MAX_INPUT: number = 500



  //minimalni delka, ktera se pocita jako opokovany dotaz na chatbota aby se prepnul na LV
  WA_MIN_INPUT_LENGTH_FOR_LV: number = 5

  WA_LV_MAX_INPUT_ERR_MSG: string = `Bylo dosaženo maximální možné délky zprávy`
  //LV msgs.
  LV_INIT_BUTTON_MSG: string = "Přepnout na online chat s operátorem"
  LV_CONFIRM_BUTTON_MSG: string = "Stále chcete spojit s operátorem?"
  LV_END_WAITING_CHAT_BUTTON_MSG: string = "Ukončit čekání na online chat s operátorem"
  LV_END_ACTIVE_CHAT_BUTTON_MSG: string = "Ukončit online chat s operátorem"
  LV_FEEDBACK_Q_MSG: string = "Pomohl Vám online chat s naším operátorem?"
  LV_FEEDBACK_B_YES_MSG: string = "Pomohl"
  LV_FEEDBACK_B_NO_MSG: string = "Nepomohl"
  LV_NO_FEEDBACK_MSG: string = "Nehodnotit" //"Přeskočit hodnocení"
  LV_SYSTEM_MSG_1: string = " se připojil/a k chatu"
  LV_SYSTEM_MSG_2: string = `Dobrý den, jmenuji se [], jak Vám mohu pomoci?`
  LV_INVALID_USER_INPUT_MSG: string = `Není povoleno zasílat odkazy operátorům. Odkaz ve zprávě bude odstraněn a nahrazen za <strong>odkaz</strong> a zpráva bude předána operátorovi.`

  LV_CONFIRM_CONSENT_BUTTON_MSG: string = 'gdpr buttons header tbd'

  //Univerzalni fronta zprav pro zobrazeni (bot, author,op)
  messages: IMessage[] = []

  //historie zadanych zprav
  localHistory: string[] = []
  localHistoryCounter: number = 0
  localHistoryInput: string = ""

  //counter odpoved pro zobrazeni LV
  answersCounter: number = 0
  singleAnswersCounter: number = 0
  multipleAnswersCounter: number = 0
  notFoundAnswersCounter: number = 0
  questionHistory: any = {}

  changeLog: string[] = [];

  inputField = new FormControl('')
  pastedInput: string = ''
  loading: boolean = false
  isOpen: boolean = false
  isVisible: boolean = false
  isPopupOpen: boolean = true
  wasPopupClosed: boolean = false
  initialButtonIsIconOnly: boolean = true

  welcomeMessageObj: IWelcomeMessage
  selectedButton: string = ''
  mainIconUrl: string = ''
  buttonIconUrl: string = ''
  isESF: boolean = true
  isIe: boolean = false

  openCounter: number = 0
  failedLoginCounter: number = 0

  isLoggedOnServer: boolean = false

  @Input() lang: string
  @Input() apikey: string
  @Input() apikey2: string
  @Input() url: string
  @Input() url2: string
  @Input() chatbotMainIconUrl: string
  @Input() chatbotButtonIconUrl: string
  @Input() parentApp: string

  //Emituje "heart beat" aktivity pro OKS
  @Output() lastActivity = new EventEmitter<any>();
  oksHeartbeatObservable$: Observable<unknown>
  oksHeartbeatSubscription: Subscription
  oksHearbeatTimeoutInterval: number = 10000 //ms (kazdych 10sec)
  oksHearbeatTimeoutWaitOpRepeat: number = 18 //pocet opakovani, tedy 18 x 10000ms => ma cekat 180 sec
  oksHearbeatTimeoutWaitUserConfirmRepeat: number = 45 //ma cekat 45 sec
  oksHearbeatTimeoutTotalRepeat: number = 10 * 6 * 60 //celkem 60 minut

  //Livechat
  //Pro intranet FALSE, pro web, online TRUE
  //Od 6.7.21 pro ON-PREM is false
  isLV: boolean = false
  livechatClient: LivechatHttpClientService
  messageBus: MessageBus
  messageSubscription: Subscription
  machineEventSub: Subscription
  fsmState: ChatMachineStatesEnum = ChatMachineStatesEnum.botLoaded
  shouldDisplayChatButtons: boolean = false
  shouldDisplayStartOpButton: boolean = false
  shouldDisplayEndWaitingOpButton: boolean = false
  shouldDisplayWaitForOpButton: boolean = false
  shouldDisplayEndActiveOpButton: boolean = false
  shouldDisplayFeedbackOpButton: boolean = false


  shouldDisplayGdprConsentButton: boolean = false

  //LV availability state, default ONLINE,OFFLINE 
  //FOR TESTING ONLY: ACTIVE
  chatAvailabilityStateEnum = ChatAvailabilityStateEnum
  globalState: GlobalStateEnum = GlobalStateEnum.BOT_OFFLINE


  //FSM pro stavy chatu
  private chatState$: Observable<unknown>


  soundError: any





  constructor(apiClient: ChatbotHttpClientService, private cd: ChangeDetectorRef, livechatClient: LivechatHttpClientService, messageBus: MessageBus, private chatStateMachine: ChatStateMachine) {
    this.apiClient = apiClient
    this.livechatClient = livechatClient
    this.messageBus = messageBus
    this.cd = cd
    Logger.setConfig(this.apikey, this.parentApp, this.lang, this.url, this.isDebug)
    this.apiClient.setOptions(version)

    //Hlaska je jina po 12.3
    if (moment().isAfter(moment(this.LV_ACTIVE_DATE).add(8, 'h'))) {
      this.WA_NOT_UNDERSTAND_TEXT = this.WA_NOT_UNDERSTAND_TEXT_AFTER_12_3
    }

    Logger.version(`Chatbot started. version: ${version}`)

  }


  /*
    pro interaktivni knofliky v odpovedich
  */
  onSelectedButton(event: string) {
    this.selectedButton = event

    this.sendMessage(event)
  }

  onSelectedToggle(event: any) {
    // console.log('toggled')
    if (this.isOpen) {
      this.updateChangesAndScroll()
    }
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    let log: string[] = [];
    Logger.info(`incoming change for: ${JSON.stringify(changes)}`)
    for (let propName in changes) {
      let changedProp = changes[propName];
      let to = JSON.stringify(changedProp.currentValue);
      if (changedProp.isFirstChange()) {
        log.push(`Initial value of ${propName} set to ${to}`);
        Logger.info(`Initial value of ${propName} set to ${to}`)
      } else {
        let from = JSON.stringify(changedProp.previousValue);
        Logger.info(`${propName} changed from ${from} to ${to}`)
        log.push(`${propName} changed from ${from} to ${to}`);
      }

      if (changes.hasOwnProperty('lang')) {
        var regexp = /^"?(.+?)"?$/;
        let to2 = to.replace(/^"?(.+?)"?$/, '$1');
        if (to2 == 'cs') {
          //hide chatbot
          this.enableChatbot(true)
        } else {
          //open chatbot 
          this.enableChatbot(false)
        }
      }

    }
    this.changeLog.push(log.join(', '));
  }

  closePopup(): void {
    this.isPopupOpen = !this.isPopupOpen
    this.wasPopupClosed = true
  }


  private myBrowser() {
    if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1) {
      return 'Opera';
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
      return 'Chrome';
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      return 'Safari';
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      return 'Firefox';
    } else if ((navigator.userAgent.indexOf("MSIE") != -1)) {
      return 'IE';
    } else {
      return 'unknown';
    }
  }

  getBrowserVersion() {
    let userAgent = navigator.userAgent
    let tem
    let matchTest = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(matchTest[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
      return 'IE ' + (tem[1] || '');
    }
    if (matchTest[1] === 'Chrome') {
      tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    matchTest = matchTest[2] ? [matchTest[1], matchTest[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = userAgent.match(/version\/(\d+)/i)) != null) matchTest.splice(1, 1, tem[1]);
    return matchTest.join(' ');
  }

  checkIfMobileBrowser(): BrowserTypeEnumSLA {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      // true for mobile device
      return BrowserTypeEnumSLA.mobile
    } else {
      // false for not mobile device
      return BrowserTypeEnumSLA.web
    }
  }

  private ieVersion() {
    var ua = window.navigator.userAgent;
    if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1) {
      if (ua.indexOf("Trident/7.0") > -1)
        return 11;
      else if (ua.indexOf("Trident/6.0") > -1)
        return 10;
      else if (ua.indexOf("Trident/5.0") > -1)
        return 9;
      else
        return 0;  // not IE9, 10 or 11
    } else {
      return -1
    }
  }

  private formatAnsweredSystemMessage(text: string): any {
    //  //console.log('-----------------------------------------------------------formatAnsweredSystemMessage DEBUG')
    let res = text
    let answered = false
    if (text.indexOf(this.LV_SYSTEM_MSG_1) > -1) {
      let namePart = text.replace(this.LV_SYSTEM_MSG_1, '')
      if (namePart && namePart.length > 0) {
        res = this.LV_SYSTEM_MSG_2.replace('[]', namePart)
        answered = true
      }
    }

    return {
      res: res,
      answered: answered
    }
  }

  private filterMessagesForLoading(shouldCheckAll: boolean) {
    //pro ostatni OP stavy odstranuji vsechny zpravy (i posledni) s ...
    let shouldRun = true
    while (shouldRun) {

      let errIdx = this.messages.findIndex((item) => {
        if (item.loading == true) {

          return true
        } else {
          return false
        }
      })

      if (errIdx == -1) {
        shouldRun = false
      } else {

        if (shouldCheckAll) {
          this.messages.splice(errIdx, 1)

        } else {
          //mazu vsechny ale ne posledni
          if (errIdx < this.messages.length - 1) {
            this.messages.splice(errIdx, 1)
          } else {
            //nemazu posledni
            shouldRun = false
          }
        }
      }
    }


  }

  isWorkingHoursForOP(): boolean {
    if (moment().isBetween(this.chatStateMachine.beforeTime, this.chatStateMachine.afterTime)) {
      Logger.info('ON: LV is open for business')
      return true
    } else {
      Logger.info('ON: LV is closed for business')
      return false
    }
  }


  async ngOnInit(): Promise<void> {
    Logger.info(`CH:Dia:ON:Running with version: ${version}`)
    Logger.info(`CH:Dia:ON:Running with: ${this.apikey} for lang: ${this.lang}, app type: ${this.parentApp}, using GTW server: ${this.url} and reporting server: ${this.url2}`)
    Logger.info(`CH:Dia:ON: Rroot component started with icon: ${this.chatbotMainIconUrl} ...`)



    //  Logger.info(this.myBrowser());
    //  Logger.info(this.getBrowserVersion());
    if (this.ieVersion() <= 0) {
      Logger.info("No IE")
    } else {
      Logger.info(`IE version: ${this.ieVersion()}`)
      this.isIe = true
    }

    Logger.info(`Running on IE: ${this.isIe}`)

    Logger.info(`Mobile/desktop: ${this.checkIfMobileBrowser()}`)


    if (this.parentApp.toLowerCase() == 'portal' || this.parentApp.toLowerCase() == 'web2') {
      //Asseco
      if (this.chatbotMainIconUrl && this.chatbotButtonIconUrl && this.chatbotMainIconUrl.length > 0 && this.chatbotButtonIconUrl.length > 0) {
        //vse ok pouzije se input par
        this.mainIconUrl = this.chatbotMainIconUrl
        this.buttonIconUrl = this.chatbotButtonIconUrl
        let tempPath = this.chatbotMainIconUrl.replace('chatbotMainIcon.png', 'error.m4a')

        this.soundError = new Howl({
          src: [tempPath]
        });

      } else {
        this.mainIconUrl = "https://sef55dzhxd8ydgp8gvxt67a1-csu-ui-test-web.cdns.apps-unitx-cloud.com/assets/chatbotMainIcon.png"
        this.buttonIconUrl = "https://sef55dzhxd8ydgp8gvxt67a1-csu-ui-test-web.cdns.apps-unitx-cloud.com/assets/chatbotButtonEnter.png"

        this.soundError = new Howl({
          src: ["https://sef55dzhxd8ydgp8gvxt67a1-csu-ui-test-web.cdns.apps-unitx-cloud.com/assets/error.m4a"]
        });
      }

      this.isESF = false

    } else {
      //OKS
      this.isESF = true
      this.mainIconUrl = "../assets/chatbotMainIcon.png"
      this.buttonIconUrl = "../assets/chatbotButtonEnter.png"
      this.soundError = new Howl({
        src: ['../assets/error.m4a']
      });

    }

    //PROD WEB (od 12.3) LV this.apikey2 == '12qpo2362791032ss1s2p909039s3qr9'
    if (moment().isAfter(moment(this.LV_ACTIVE_DATE).add(8, 'h')) && this.apikey2 == '12qpo2362791032ss1s2p909039s3qr9') {
      this.isLV = true
    } else {
      this.isLV = false
    }

    if (this.apikey2 != '12qpo2362791032ss1s2p909039s3qr9') {
      if (this.apikey2 == 'na' || this.apikey2 == null || this.url2 == 'na' || this.url2 == null) {
        this.isLV = false
      } else {
        this.isLV = true
      }
    }

    if (this.lang == 'cs') {
      this.isVisible = true
    }

    if (this.apikey === "a124ecd6-e9f2-4401-aeed-7543b35b43d7") {
      //LocalDev, cloud dev
      this.isDebug = true
    } else if (this.apikey === "002030d6-aa53-4e31-ad65-cf0f9f1c3e3e") {
      //TEST       
      this.isDebug = true

    } else {
      //prod TBD, ale pravdepodobne bez logovani
      this.isDebug = false

    }
    Logger.info(`CH:Dia:ON:${version}: Running with: ${this.apikey} for lang: ${this.lang}, app type: ${this.parentApp}, using server: ${this.url}. LV active: ${this.isLV}`)
    if (this.isLV && this.isWorkingHoursForOP()) {
      this.livechatClient.initWithDataForSLA(this.parentApp, this.checkIfMobileBrowser(), this.url2, this.apikey2)
    } else {
      //neinicializuji LV
    }

    if (this.isDebug) {
      Logger.info(`CH:Dia:ON:Setting debug mode to: DEV, TEST (logging all)`)
    } else {
      Logger.info(`CH:Dia:ON:Setting debug mode to: PROD (logging nothing)`)

    }

    /*
   Inicializace State machine a subscribe na FSM observable

   DULEZITE: na zaklade stavu se nastavuji ruzne UI priznaky
   */
    //console.log("D==============================================================")
    let notifSoundPath
    if (!this.isESF) {
      notifSoundPath = this.chatbotMainIconUrl.replace('chatbotMainIcon.png', 'notification.m4a')
    } else {
      notifSoundPath = "../assets/notification.m4a"
    }

    this.chatStateMachine.init(this.apikey2, notifSoundPath, this.parentApp)
    this.chatState$ = from(this.chatStateMachine.activeMachine);

    this.chatState$.subscribe((state: any) => {
      Logger.info('*'.repeat(100))
      Logger.info(`ROOT: SUBSCRIBEd TO FSM state changes. New state: ${JSON.stringify(state)}`)

      //Posilani heart-beat aktivity do OKS i podle zmenu stavu pri cekani ZDE nemuze byt - hlasi to chybu v konzoli
      // this.lastActivity.emit(moment().toISOString())

      if (state && state.value) {
        this.fsmState = state.value
        Logger.info('*'.repeat(100))
        Logger.info(`ROOT: NEW FSM STATE NAME: ${state.value}`)
        Logger.info('*'.repeat(100))

        /*
          unsubscribe OKS hearbeat
        */
        if (this.oksHeartbeatSubscription) {
          this.oksHeartbeatSubscription.unsubscribe()
        }

        if (state.value == ChatMachineStatesEnum.botAvailable || state.value == ChatMachineStatesEnum.botActiveOpBusy || state.value == ChatMachineStatesEnum.botActiveOpError || state.value == ChatMachineStatesEnum.botActiveAndWaitingToStartOfferOp || state.value == ChatMachineStatesEnum.botActiveOpDisabled) {
          /*
          pro OK stavy bota -> posilaji se na nej zpravy
          */
          this.shouldDisplayChatButtons = false
          this.shouldDisplayStartOpButton = false
          this.shouldDisplayEndWaitingOpButton = false
          this.shouldDisplayWaitForOpButton = false
          this.shouldDisplayEndActiveOpButton = false
          this.shouldDisplayFeedbackOpButton = false
          this.shouldDisplayGdprConsentButton = false
          //  console.log('================================DEBUG')
          this.filterMessagesForLoading(true)
          if (this.isOpen) {
            this.updateChangesAndScroll()
          }

        }


        if (state.value == ChatMachineStatesEnum.botError || state.value == ChatMachineStatesEnum.opBusyBotError || state.value == ChatMachineStatesEnum.opErrorBotError) {
          /*
          pro chybove stavy bota -> ale stejne se na nej posilaji zpravy
          botErrorPrechodny stav -> neni nutne resit v UI co se deje v tomto stavu
          */
          this.shouldDisplayChatButtons = false
          this.shouldDisplayStartOpButton = false
          this.shouldDisplayEndWaitingOpButton = false
          this.shouldDisplayWaitForOpButton = false
          this.shouldDisplayEndActiveOpButton = false
          this.shouldDisplayFeedbackOpButton = false
          this.shouldDisplayGdprConsentButton = false

          //Stale muze posilat na bot a dostat chybu


        }

        if (state.value == ChatMachineStatesEnum.botActiveOfferingOp || state.value == ChatMachineStatesEnum.opAvailableBotError) {
          //zobrazit tlacitko pro zahajeni LV
          this.shouldDisplayChatButtons = true
          this.shouldDisplayStartOpButton = true
          this.shouldDisplayEndWaitingOpButton = false
          this.shouldDisplayWaitForOpButton = false
          this.shouldDisplayEndActiveOpButton = false
          this.shouldDisplayFeedbackOpButton = false
          this.shouldDisplayGdprConsentButton = false
          //Stale muze posilat na bot


        }

        if (state.value == ChatMachineStatesEnum.opWaitingForGdprConsent) {
          //zobrazit tlacitko pro zahajeni LV
          this.shouldDisplayChatButtons = false
          this.shouldDisplayStartOpButton = false
          this.shouldDisplayEndWaitingOpButton = false
          this.shouldDisplayWaitForOpButton = false
          this.shouldDisplayEndActiveOpButton = false
          this.shouldDisplayFeedbackOpButton = false
          this.shouldDisplayGdprConsentButton = true
          //Stale muze posilat na bot
          //Poslat zpravu na server o tom, ze uzivatel pozadal o KC

          this.logRequestForOpToServer()

        }

        if (state.value == ChatMachineStatesEnum.opWaitingForOp1 || state.value == ChatMachineStatesEnum.opWaitingForOp2) {
          //cekani na reakci uzivatele ukoncit LV pri cekani na op
          this.shouldDisplayChatButtons = true
          this.shouldDisplayStartOpButton = false
          this.shouldDisplayEndWaitingOpButton = false
          this.shouldDisplayWaitForOpButton = false
          this.shouldDisplayEndActiveOpButton = false
          this.shouldDisplayFeedbackOpButton = false
          this.shouldDisplayGdprConsentButton = false

          //Stale muze posilat na bot


          //Pro zpozdene zobrazeni button pro zruseni
          setTimeout(() => {
            if (this.fsmState == ChatMachineStatesEnum.opWaitingForOp1 || this.fsmState == ChatMachineStatesEnum.opWaitingForOp2) {
              this.shouldDisplayEndWaitingOpButton = true
            } else {
              this.shouldDisplayEndWaitingOpButton = false
            }

          }, 10000);

          //Spustit hearbeat pro OKS
          this.runHeartbeatEventsForOKS(this.oksHearbeatTimeoutWaitOpRepeat)

          //zkusit otevrit zavrene okno


        }
        if (state.value == ChatMachineStatesEnum.opWaitingForUser) {
          //zobrazit tlacitko pro potvrzeni pokracovani cekani na OP
          this.shouldDisplayChatButtons = false
          this.shouldDisplayStartOpButton = false
          this.shouldDisplayEndWaitingOpButton = false
          this.shouldDisplayWaitForOpButton = true
          this.shouldDisplayEndActiveOpButton = false
          this.shouldDisplayFeedbackOpButton = false
          this.shouldDisplayGdprConsentButton = false

          //Stale muze posilat na bot
          this.runHeartbeatEventsForOKS(this.oksHearbeatTimeoutWaitUserConfirmRepeat)

          //zkusit otevrit zavrene okno


        }

        if (state.value == ChatMachineStatesEnum.opActive) {
          //uz posila na LV
          this.shouldDisplayChatButtons = true
          this.shouldDisplayStartOpButton = false
          this.shouldDisplayEndWaitingOpButton = false
          this.shouldDisplayWaitForOpButton = false
          this.shouldDisplayEndActiveOpButton = true
          this.shouldDisplayFeedbackOpButton = false
          this.shouldDisplayGdprConsentButton = false


          this.runHeartbeatEventsForOKS(this.oksHearbeatTimeoutTotalRepeat)

        }


        if (state.value == ChatMachineStatesEnum.opFeedback) {
          //zobrazit tlacitko pro zahajeni LV
          this.shouldDisplayChatButtons = false
          this.shouldDisplayStartOpButton = false
          this.shouldDisplayEndWaitingOpButton = false
          this.shouldDisplayWaitForOpButton = false
          this.shouldDisplayEndActiveOpButton = false
          this.shouldDisplayFeedbackOpButton = true
          this.shouldDisplayGdprConsentButton = false

          //uz posila na BOT
          //vycisteni zprav jiz pri feedback chatu
          this.filterMessagesForLoading(true)

        }


        if (state.value == ChatMachineStatesEnum.opEnded) {
          //Nastane pouze po explicitnim ukonceni/nenavazani chatu nebo po feedback stavu
          this.shouldDisplayChatButtons = false
          this.shouldDisplayStartOpButton = false
          this.shouldDisplayEndWaitingOpButton = false
          this.shouldDisplayWaitForOpButton = false
          this.shouldDisplayEndActiveOpButton = false
          this.shouldDisplayFeedbackOpButton = false
          this.shouldDisplayGdprConsentButton = false

          //Musim zjistit do jakeho stavu mam klienta dat

          //jiz neposila posila na LV -> znovu na bot

          //reset pocitacu na zobrazeni LV
          this.answersCounter = 0
          this.singleAnswersCounter = 0
          this.multipleAnswersCounter = 0
          this.notFoundAnswersCounter = 0

          //vycisteni zprav po ukonceni chatu
          this.filterMessagesForLoading(true)
          if (this.isOpen) {
            this.updateChangesAndScroll()
          }
          this.checkBotServerByLogin()

          //vyprazdeni historie zprav
          this.questionHistory = {}

        }


        if (state.value != ChatMachineStatesEnum.botLoaded) {
          if (this.isOpen) {
            this.updateChangesAndScroll()
          }
        }

        if (state.value == ChatMachineStatesEnum.opDidNotStart) {

          this.filterMessagesForLoading(true)
          if (this.isOpen) {
            this.updateChangesAndScroll()
          }

        }

      } else {
        //neni stav -> asi hide, reset ? nebo botError?
      }


    });



    /*
       ZDE SE posilaji VSECHNY odpovedi na zobrazeni, 
       JEDINE ZDE JE MOZNE messages.push a re-formatovani LV system messages
    */



    function createMsg(msg: string, from: IdOptions, mode, loading): IMessage {
      return {
        from: {
          avatar: "",
          id: from,
          name: "",
          photo: ""
        },
        message: [msg],
        message2: [],
        timeStamp: moment().toISOString(),
        generic: {},
        parsedMessage: "",
        parsedButtons: [],
        shouldDisplayButtons: false,
        index: mode, //bud -1 pro BEZ animace, nebo -2 specialni animacni zprava pri cekani na operatora
        loading: loading
      }
    }



    this.messageSubscription = this.messageBus.getMessage().subscribe(message => {
      Logger.info(`PARENT: got message from bus: ${JSON.stringify(message)}`)
      //  //console.log(`PARENT: got message from bus: ${JSON.stringify(message)}`)

      if (message.from.id != 'author') {
        // //console.log(`PARENT: got message from bus: ${JSON.stringify(message)}`)

        //XBOT
        if (message.from.id === "xbot") {
          if (this.messages.length > 0 && this.messages[this.messages.length - 1].loading) {
            if (message.from.id === this.messages[this.messages.length - 1].from.id) {
              if (!message.loading) {
                //nahrazeni ... zpravy naslednym prichozim textem
                this.messages[this.messages.length - 1] = message
              }
            }
          } else {
            //nejsou predchozi ... primo zprava
            this.messages.push(message);
          }

          //nejakym nedopatrenim je stale v poli loading -> odmazat
          let errIdx = this.messages.findIndex((item) => {
            if (item.loading == true) {

              return true
            } else {
              return false
            }
          })
          if (errIdx != -1 && errIdx < (this.messages.length - 1)) {
            //maze NE posledni loading (posledni musi zustat  )
            this.messages.splice(errIdx, 1)
          }
          if (this.isOpen) {
            this.updateChangesAndScroll()
          }
        }

        //OP
        if (message.from.id === "op") {
          // console.log(`--------------------------------------------------------- PARENT: got OP message from bus: ${JSON.stringify(message)}`)

          //reformatovani sys.zprav LV
          let answeredRes = this.formatAnsweredSystemMessage(message.message[0])
          message.message[0] = answeredRes.res

          //kontrola na zavreno okno, otevrit
          this.openChatbotDialogOnly()

          this.filterMessagesForLoading(true)

          //je nutno  pridat dodatecnou zpravu s teckama (nez prijde dalsi zprava (ALE NE PRO STAV OPACTIVE)
          if (this.fsmState === ChatMachineStatesEnum.opWaitingForOp1 || this.fsmState === ChatMachineStatesEnum.opWaitingForOp2 || this.fsmState === ChatMachineStatesEnum.opWaitingForUser) {

            //vkladam prichozi zpravu
            this.messages.push(message);


            let loadingMsg: IMessage

            if (!answeredRes.answered && message.loading == false) {
              setTimeout(() => {
                if (this.fsmState === ChatMachineStatesEnum.opWaitingForOp1 || this.fsmState === ChatMachineStatesEnum.opWaitingForOp2 || this.fsmState === ChatMachineStatesEnum.opWaitingForUser) {

                  loadingMsg = createMsg('', "op", -2, true)

                  this.messages.push(loadingMsg);
                }
                this.filterMessagesForLoading(false)
                if (this.isOpen) {
                  this.updateChangesAndScroll()
                }
              }, (Math.random() * 1000) + 500)
            }




          } else {
            //Pro ostatni stavy se nepridavaji tecky
            this.messages.push(message);
            this.filterMessagesForLoading(true)
            if (this.isOpen) {
              this.updateChangesAndScroll()
            }

          }



        }



      } else {
        //pro odchozi message se nic neresi
        this.messages.push(message);
      }
    })






    //testovani

    /*
       
    
        setTimeout(() => {
          //console.log("#".repeat(50))
          //console.log("LV - NEW CHAT ....1")
          if (this.chatStateStatus == ChatMachineStatesEnum.ONLINE) {
            this.livechatClient.createNewChat(this.messages)
          } else {
            Logger.error(`ERR: not possible to start LV session from status: ${this.chatStateStatus}`)
          }
    
        }, 5000)
    */
    /*
        setTimeout(() => {
          //console.log("###########################################################################")
          //console.log("PARENT trying to end chat...")
          this.livechatClient.endChatReq()
    
    
    
        }, 10000)
    */


  }

  /*
    RxJS interval implementation for heart-beat to OKS parent app
  */
  runHeartbeatEventsForOKS(repeat: number): void {
    this.oksHeartbeatObservable$ = interval(this.oksHearbeatTimeoutInterval);
    this.oksHeartbeatSubscription = this.oksHeartbeatObservable$.pipe(take(repeat)).subscribe(x => {
      //  //console.log(`------------------------------------------------------- DEBUG heartbet: ${x}`)
      this.lastActivity.emit(moment().toISOString())

    })
  }

  /**
   * Zjisti dostupnost v pripade aktualni chyby a nastavi stav FSM ....
   */
  public async checkAvailabilityBeforeSendMessage(): Promise<void> {

    if (this.fsmState == ChatMachineStatesEnum.botError || this.fsmState == ChatMachineStatesEnum.botErrorOpOffshift) {
      /*
      kontroluji POUZE dostupnost chatbota, pozor botError je pouze transitivni stav
      NEMUSIM IMPLEMENTOVAT - chatbot to dela automaticky
*/

    }

    if (this.fsmState == ChatMachineStatesEnum.opBusyBotError || this.fsmState == ChatMachineStatesEnum.opErrorBotError) {
      //kontroluji dostupnost obou sluzbe

    }

    if (this.fsmState == ChatMachineStatesEnum.botActiveOpBusy || this.fsmState == ChatMachineStatesEnum.botActiveOpError) {
      //kontroluji dostupnost LV

    }
  }


  public shouldSendMessagesToBot(): boolean {
    if (this.fsmState == ChatMachineStatesEnum.opActive) {
      return false
    } else {
      return true
    }
  }


  createMsg(msg: string, from: IdOptions, mode, loading): IMessage {
    return {
      from: {
        avatar: "",
        id: from,
        name: "",
        photo: ""
      },
      message: [msg],
      message2: [],
      timeStamp: moment().toISOString(),
      generic: {},
      parsedMessage: "",
      parsedButtons: [],
      shouldDisplayButtons: false,
      index: mode, //bud -1 pro BEZ animace, nebo -2 specialni animacni zprava pri cekani na operatora
      loading: loading
    }
  }

  /*
      vlastni login a hlasky chatbota
  */

  public async makeLogin(): Promise<Object> {
    this.loading = true;
    //Nastaveni axios podle config z parentApp - ziskani pocatecniho osloveni, atd..
    let loginOptions: LoginOptions = {
      method: "post",
      instanceId: this.apikey,
      url: this.url,
      params: {
        id: this.apikey,
        channel: this.parentApp == 'cypress' || this.parentApp == 'uptrends' ? this.parentApp : `${this.parentApp}$${version}`
      }
    }
    try {
      Logger.info(`VERSION: ${version}: CH:Dia:makeLogin request with: ${JSON.stringify(loginOptions)}`)

      let res = await this.apiClient.makeLogin(loginOptions)
      // console.log('DEBUG=====================')
      Logger.info(`VERSION: ${version}: CH:Dia:makeLogin result: ${JSON.stringify(res)}`)
      if (res) {
        this.welcomeMessageObj = res

        if (this.welcomeMessageObj.notUnderstandText && this.welcomeMessageObj.notUnderstandText.length > 0) {
          //pouziji ze serveru
          this.WA_NOT_UNDERSTAND_TEXT = this.welcomeMessageObj.notUnderstandText
        }

        if (this.welcomeMessageObj.errorText && this.welcomeMessageObj.errorText.length > 0) {
          //pouziji ze serveru
          this.WA_ERROR_TEXT = this.welcomeMessageObj.errorText
        }
        if (this.welcomeMessageObj.maxInput && this.welcomeMessageObj.maxInput > 0) {
          //pouziji ze serveru
          this.WA_MAX_INPUT = this.welcomeMessageObj.maxInput
        }

        if (this.welcomeMessageObj.welcomeMessage && this.welcomeMessageObj.welcomeMessage.length > 0) {
          //pouziji ze serveru
          this.WA_WELCOME_MESSAGE = this.welcomeMessageObj.welcomeMessage

          //PRVNI uvodni hlaska
          if (this.messages.length <= 1) {
            this.messages = []
            this.messageBus.publishMessageToBus(this.saveAndCreateWelcomeMessage(this.WA_WELCOME_MESSAGE))
          }
        }

        this.isLoggedOnServer = true

        if (this.failedLoginCounter > 0) {
          if (this.fsmState == ChatMachineStatesEnum.opEnded) {
            this.messageBus.publishMessageToBus(this.createMsg(this.LV_OP_BACK_TO_AVAILABLE_CHAT_MSG, "xbot", -1, false))
          } else {
            this.messageBus.publishMessageToBus(this.saveAndCreateWelcomeMessage(this.WA_ERROR_FIXED_TEXT))
          }
        }


        //Reset coutner pro zobrazeni err hlasky po naslednem uspesnem prihlaseni
        this.failedLoginCounter == 0
        this.loading = false
        return true
      } else {
        throw ('No response from login')
      }
    } catch (err) {

      this.isLoggedOnServer = false
      this.loading = false
      Logger.error(`VERSION: ${version}: CH:Dia:makeLogin error: ${JSON.stringify(err)}`)

      if (this.failedLoginCounter == 0) {
        this.messageBus.publishMessageToBus(this.createWelcomeErrorMessage(this.WA_ERROR_TEXT))
      } else {

        this.messageBus.publishMessageToBus(this.saveAndCreateWelcomeMessage(this.WA_ERROR_NOT_FIXED_TEXT))

      }

      this.failedLoginCounter += 1
      return false
    }

  }

  async openChatbotDialog(): Promise<void> {

    Logger.info(`CH:Dia: going from isOpen: ${this.isOpen} to isOpen: ${!this.isOpen}`)
    this.isOpen = !this.isOpen

    if (this.isPopupOpen) {
      this.isPopupOpen = !this.isPopupOpen

    }

    if (this.openCounter == 0) {
      // this.messageBus.publishMessageToBus(this.saveAndCreateWelcomeMessage(this.WA_WELCOME_MESSAGE))
    }
    this.openCounter += 1

    await this.checkBotServerByLogin()

  }

  private openChatbotDialogOnly(): void {
    this.isOpen = true
    if (this.isPopupOpen) {
      this.isPopupOpen = false

    }
  }



  async checkBotServerByLogin(): Promise<void> {
    if (!this.isLoggedOnServer) {
      try {

        Logger.info(`CH:Dia: NOT Yet Logged on server and going to call 'makeLogin`)



        let result = await this.makeLogin()
        if (result) {
          Logger.info(`CH:Dia: NOW Logged (after previous error) on server with result: ${result}`)
          if (this.isLV && this.isWorkingHoursForOP()) {
            //dodatecna kontrola pretizenosti daktela - ZRUSENO PRO ON-PREM 6.7.21
           // let availRes = await this.livechatClient.checkGlobalStatus()
            let availRes = false

            if (availRes) {
              //v poradku ze bot_online -> kontroluje se nasledne busy/online a pracovni doba (jeste jednou)
              this.chatStateMachine.updateState({ type: ChatMachineEventEnum.BOT_ONLINE, value: { isError: false } })
              this.globalState = GlobalStateEnum.BOT_ONLINE
            } else {
              //v pripade globalni blokace nebo mimo pracovni dobu
              this.chatStateMachine.updateState({ type: ChatMachineEventEnum.OP_DISABLED, value: { isError: false } })
            }
          } else {
            //v pripade ze jeste neni KC spusteno nebo mimo pracovni dobu
            this.chatStateMachine.updateState({ type: ChatMachineEventEnum.OP_DISABLED, value: { isError: false } })

          }
        } else {
          Logger.info(`CH:Dia: Server LOGON failed with result: ${result}`)
          if (this.isLV && this.isWorkingHoursForOP()) {
            //TESTING
            //  this.chatStateMachine.updateState({ type: ChatMachineEventEnum.TESTING, value: {isError:true}})
             //dodatecna kontrola pretizenosti daktela - ZRUSENO PRO ON-PREM 6.7.21
           // let availRes = await this.livechatClient.checkGlobalStatus()
           let availRes = false
            if (availRes) {
              this.chatStateMachine.updateState({ type: ChatMachineEventEnum.BOT_OFFLINE, value: { isError: true } })
              this.globalState = GlobalStateEnum.BOT_OFFLINE
            } else {
              this.chatStateMachine.updateState({ type: ChatMachineEventEnum.OP_DISABLED, value: { isError: false } })

            }
          } else {
            //v pripade ze jeste neni KC spusteno nebo mimo pracovni dobu
            this.chatStateMachine.updateState({ type: ChatMachineEventEnum.OP_DISABLED, value: { isError: false } })

          }
        }

      } catch (err) {

        Logger.error(`CH:DIA checkBotServerByLogin err: ${JSON.stringify(err)}`)
        if (this.isLV && this.isWorkingHoursForOP()) {
          this.chatStateMachine.updateState({ type: ChatMachineEventEnum.BOT_OFFLINE, value: { isError: true } })
          this.globalState = GlobalStateEnum.BOT_OFFLINE
        } else {
          this.chatStateMachine.updateState({ type: ChatMachineEventEnum.OP_DISABLED, value: { isError: false } })

        }

      }
    } else {
      //Prihlasen na API server
      if (this.isLV && this.isWorkingHoursForOP()) {
        if (this.fsmState == ChatMachineStatesEnum.opEnded) {
          this.messageBus.publishMessageToBus(this.createMsg(this.LV_OP_BACK_TO_AVAILABLE_CHAT_MSG, "xbot", -1, false))
        }
        Logger.info(`CH:Dia: Already logged on. Going to OPEN`)
        this.chatStateMachine.updateState({ type: ChatMachineEventEnum.BOT_ONLINE, value: { isError: false } })
        this.globalState = GlobalStateEnum.BOT_ONLINE
      } else {
        this.chatStateMachine.updateState({ type: ChatMachineEventEnum.OP_DISABLED, value: { isError: false } })
      }
    }



  }

  saveAndCreateWelcomeMessage(input: string): IMessage {

    let output: IMessage = {
      from: {
        avatar: "/img/icons/CSU/Icon_color.png",
        id: "xbot",
        name: "",
        photo: ""
      },
      message: [input],
      message2: [],
      timeStamp: moment().toISOString(),
      generic: {},
      parsedMessage: "",
      parsedButtons: [],
      shouldDisplayButtons: false,
      index: -1,
      loading: false
    }

    return output
  }

  createWelcomeErrorMessage(input: string): IMessage {

    let output: IMessage = {
      from: {
        avatar: "/img/icons/CSU/Icon_color.png",
        id: "xbot",
        name: "",
        photo: ""
      },
      message: [input],
      message2: [],
      timeStamp: moment().toISOString(),
      generic: {},
      parsedMessage: "",
      parsedButtons: [],
      shouldDisplayButtons: false,
      index: -1,
      loading: false
    }

    return output
  }


  /*
    V pripade bot-offline se prvni zprava nezobrazuje (jinak tam jsou 2x)
  */

  private prepareRequestToWatson(input: string, shouldDisplay: boolean) {


    let text = input

    let payload: IPayloadToWatson

    //create message for messages
    let output: IMessage = {
      from: {
        avatar: "",
        id: "author",
        name: "",
        photo: ""
      },
      message: [text],
      message2: [],
      timeStamp: moment().toISOString(),
      generic: {},
      parsedMessage: "",
      parsedButtons: [],
      shouldDisplayButtons: false,
      index: -1, //pro author specialni hodnota
      loading: false
    }

    //users messages/otazky se posilaji rovnou
    if (shouldDisplay) {
      this.messages.push(output)
    }

    payload = {
      text: text,
      timestamp: moment().toISOString(),
      txStartTimestamp: '',
      txEndTimestamp: '',
      isLoginTx: true,
      channel: this.parentApp == 'cypress' || this.parentApp == 'uptrends' ? this.parentApp : `${this.parentApp}$${version}`
      //channel: 'uptrends'
    }

    return payload
  }

  /*
  WIP 
  pro odstraneni HTML tagu ze zpravy ale pro pocatecni/koncove <p> to je moc komplexni jako funkce
  */


  removeSubstringFromMessage(inStr: String, subStr: String): String {
    let outStr = inStr

    let tempMsg = inStr.slice(subStr.length)
    outStr = tempMsg
    return outStr
  }

  /*
      formatovani zpravy (buttons)
      presunuto z message kvuli OKS renderingu 20.6.20
  */
  parseMessage(message: IMessage): IMessage {
    let parsedMessage: string
    let parsedButtons: string[] = []

    message.shouldDisplayButtons = false

    Logger.info(`${moment().toISOString()}: M: got new message to PARSE: ${JSON.stringify(message)} from source: ${message.from.id}`)
    if (message.from.id === 'xbot') {
      if (typeof (message) === 'object') {
        //  Logger.info(`M type: ${typeof (message)} for message: ${message}`)
        if (Array.isArray(message.message)) {

          if (typeof (message.message[0]) === 'string' && message.message.length > 0) {
            if (message.from.id == 'xbot' && message.message.length > 0) {
              let buttons = message.message.filter((item) => {
                if (item == "buttons") {
                  return true
                }
              })
              if (buttons.length == 2) {
                //Valid buttons komponenta
                let tempMessage: any = this.parseButtons(message.message)
                parsedMessage = tempMessage.text[0]
                if (tempMessage.buttons.length > 0) {
                  //mame 1+ button
                  parsedButtons = tempMessage.buttons
                  message.shouldDisplayButtons = true
                }
              } else {
                if (message.message.length == 1) {

                  //22.9.20 -> musim odstranit <p></p> ze zpravy, dela to vetsi okraje
                  if (message.message[0].startsWith('<p>') && message.message[0].endsWith('</p>')) {
                    let tempStr = message.message[0].slice('<p>'.length)
                    let tempStr2 = tempStr.slice(0, tempStr.length - '</p>'.length)
                    Logger.info(`Message1 After <p>/</p> removal: ${tempStr2}`)
                    parsedMessage = tempStr2
                    message.message[0] = tempStr2
                  }



                }
              }

              //<p></p> parsing (architect source) pro message2
              if (message.message2 && message.message2.length == 1 && message.message2[0] && message.message2[0].length > 0) {

                //22.9.20 -> musim odstranit <p></p> ze zpravy, dela to vetsi okraje
                if (message.message2[0].startsWith('<p>') && message.message2[0].endsWith('</p>')) {
                  let tempStr = message.message2[0].slice('<p>'.length)
                  let tempStr2 = tempStr.slice(0, tempStr.length - '</p>'.length)
                  Logger.info(`Message2 After <p>/</p> removal: ${tempStr2}`)

                  message.message2[0] = tempStr2
                }



              }

            }
          } else {
            Logger.error(`POtentially Unsupported type: ${typeof (message)} for message: ${JSON.stringify(message)}`)
            parsedMessage = message[0]
          }


        } else {
          Logger.error(`Unsupported type 1: ${typeof (message)} for message: ${JSON.stringify(message)}`)
        }
      } else {
        Logger.error(`Unsupported type 2: ${typeof (message)} for message: ${JSON.stringify(message)}`)
        if (typeof (message) === 'string') {
          parsedMessage = message
        } else {
          parsedMessage = ''
        }
      }
    }

    message.parsedButtons = parsedButtons
    message.parsedMessage = parsedMessage

    return message

  }


  parseButtons(msg) {
    let response: any = {}
    if (msg.length > 0) {
      //odstrani posledni buttons control element
      msg.pop();

      var shouldContinue = true;
      var buttonsTemp = []
      while (shouldContinue) {
        if (msg[msg.length - 1] == 'buttons') {
          msg.pop();
          shouldContinue = false
        } else {
          buttonsTemp.splice(0, 0, msg.pop());
        }

      }
      //odstrani element, ktery se ma stat bundleRenderer.renderToStream

      if (msg.length > 0) {
        //ok
        if (buttonsTemp.length > 0) {
          response.buttons = buttonsTemp;
          response.text = msg

        } else {
          Logger.info("error in output text handling logic")
        }
        return response;

      } else {
        Logger.info("error in output text handling logic")
      }
    }



  }


  /*
    Prijim zpravu z WA 
  */

  handleResponseFromServer(result, input: string) {
    try {
      //  //console.log(`---------------------------------------------------------- DEbug result from bot`)
      Logger.info(JSON.stringify(this.questionHistory))

      //pridani LV counters
      if (result.text[0] === this.WA_ERROR_TEXT) {
        //okamzite zvysuji na zobrazeni na OP
        this.answersCounter = 10
      } else {
        if (!this.questionHistory.hasOwnProperty(input) && input.length >= this.WA_MIN_INPUT_LENGTH_FOR_LV) {
          //otazka jeste nebyla polozena, musi se pridat do DICT kvuli unikatnosti a do pole 
          this.questionHistory[input] = input
          if (result.text[0] === this.WA_BY_MSG || result.text[0] === this.WA_INTRO_MSG) {
            //pri pozdravu/rozlouceni se nezvetsuje

          } else {
            if (result.text[0] === this.WA_NOT_UNDERSTAND_TEXT) {
              this.notFoundAnswersCounter += 1
            } else if (result.text.indexOf('buttons') > -1) {
              this.multipleAnswersCounter += 1
            } else {
              //odpoved s jednou variantou 
              this.singleAnswersCounter += 1
            }

            this.answersCounter += 1
          }

        } else {
          //pokud byla jiz polozena / nebo je prilis kratka tak se counters nezvysuji
          Logger.info(`Question: ${input} was already asked/is stop question and not counted. Chat button will be displayed LATER`)
        }

      }

      let output: IMessage = {
        from: {
          avatar: "",
          id: "xbot",
          name: "",
          photo: ""
        },
        message: result.text,
        message2: result.text2,
        timeStamp: moment().toISOString(),
        generic: {},
        parsedMessage: "",
        parsedButtons: [],
        shouldDisplayButtons: false,
        index: (this.messages.length - 1), //tak aby to byl posledni index
        loading: false

      }
      Logger.info(`${moment().toISOString()} before parsing message.  Message from server: ${JSON.stringify(output)}`)

      let output2 = this.parseMessage(output)

      Logger.info(`${moment().toISOString()} before push message to messages. Parsed message: ${JSON.stringify(output2)}`)

      this.messageBus.publishMessageToBus(output2)

    } catch (err) {
      Logger.error(`CH:handleResponseFromServer unexpected error: ${JSON.stringify(err)}`)
      return ("unexpected-err");
    }

  }

  handleErrorResponseFromXXX(mode: IdOptionsEnum, message: string) {

    //teprve druha odpoved se zapisuje do messages
    let output: IMessage = {
      from: {
        avatar: "",
        id: mode,
        name: "",
        photo: ""
      },
      message: [message],
      message2: [],
      timeStamp: moment().toISOString(),
      generic: {},
      parsedMessage: "",
      parsedButtons: [],
      shouldDisplayButtons: false,
      index: this.messages.length,
      loading: false

    }
    //Pridani vysokeho citace odpovedi -> vede k okamzitemu zobrazeni livecha button
    this.answersCounter = 10
    Logger.info(`${moment().toISOString()} before push message to messages (Err)`)
    this.messageBus.publishMessageToBus(output)



  }

  updateChangesAndScroll(): void {
    updateTimer.subscribe(() => {
      // Logger.info(`${moment().toISOString()} before detectChanges() timer1 subscribe event (Err)`)
      this.cd.detectChanges()

    })
    scrollingTimer.subscribe(() => {
      // Logger.info(`${moment().toISOString()} before delayed scrolling timer2 subscribe event (Err)`)
      this.updateScroll()
    })
  }

  checkIfhiddenThenOpenChatbot(): void {
    Logger.info(`CH:Dia: Checking if hidden, going to open on incoming message/event from OP. FSM state: ${this.fsmState}`)

    /*
    if (!this.isOpen) {
      if (this.wasPopupClosed) {
        this.isPopupOpen = false
      } else {
        this.isPopupOpen = true
      }
    }

    let stateTemp = this.chatStateMachine.getState()
    //console.log(stateTemp)

    //TBD, zatim 
    if (stateTemp == ChatMachineStatesEnum.opBusyBotError || stateTemp == ChatMachineStatesEnum.opErrorBotError
      || stateTemp == ChatMachineStatesEnum.botErrorOpOffshift) {
      //V tomto pripade by se mel system resetovat do botLoaded, vymazat vsechny zpravy a zkusit znovu inicializaci ??
      //console.log(`FSM ERR state found: ${stateTemp} on hiding chatbt-> ??? reseting system to botLoaded state ???`)
    }

    */

  }

  hideChatbot(): void {
    Logger.info(`CH:Dia: Going to hide`)
    this.isOpen = false

    if (!this.isOpen) {
      if (this.wasPopupClosed) {
        this.isPopupOpen = false
      } else {
        this.isPopupOpen = true
      }
    }

    let stateTemp = this.chatStateMachine.getState()
    ////console.log(stateTemp)


    //TBD, zatim 
    /*
    if (stateTemp == ChatMachineStatesEnum.opBusyBotError || stateTemp == ChatMachineStatesEnum.opErrorBotError
      || stateTemp == ChatMachineStatesEnum.botErrorOpOffshift) {
      //V tomto pripade by se mel system resetovat do botLoaded, vymazat vsechny zpravy a zkusit znovu inicializaci ??
      //console.log(`FSM ERR state found: ${stateTemp} on hiding chatbt-> ??? reseting system to botLoaded state ???`)
    }
*/
  }

  @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if (event.key === "Escape") {
      this.hideChatbot()
    } else if (event.key === 'ArrowUp') {
      //sipka nahoru
      if (this.localHistory.length > 0) {
        let index = this.localHistory.length - (1 + this.localHistoryCounter)
        if (index >= 0) {
          this.localHistoryInput = this.localHistory[index]
          this.localHistoryCounter += 1

          this.inputField.setValue(this.localHistoryInput)
        }
      }
    } else {
      //console.log(event.key)
      if (event.key != "Enter") {
        if (this.fsmState == ChatMachineStatesEnum.opActive) {
          if (this.inputField.value.length >= this.LV_MAX_INPUT) {
            if (this.messages[this.messages.length - 1].message[0] != this.WA_LV_MAX_INPUT_ERR_MSG) {
              this.messageBus.publishMessageToBus(this.createMsg(this.WA_LV_MAX_INPUT_ERR_MSG, "op", -1, false))
            }
            this.inputField.setValue(this.inputField.value.substring(0, this.LV_MAX_INPUT - 1))
            this.soundError.play()

          }
        } else {
          // let WA_MAX_INPUT_TEST = 2
          if (this.inputField.value.length >= this.WA_MAX_INPUT) {
            if (this.messages[this.messages.length - 1].message[0] != this.WA_LV_MAX_INPUT_ERR_MSG) {
              this.messageBus.publishMessageToBus(this.createMsg(this.WA_LV_MAX_INPUT_ERR_MSG, "xbot", -1, false))
            }
            this.inputField.setValue(this.inputField.value.substring(0, this.WA_MAX_INPUT - 1))
            this.soundError.play()
          }

        }
      }
      // console.log(`---------------------------------------------------------- DEbug: ${this.inputField.value.length}`)
    }
  }

  enableChatbot(shouldEnable: boolean): void {

    Logger.info(`CH:Dia: shouldEnable from ${this.isVisible} -> to: ${shouldEnable}`)
    this.isVisible = shouldEnable

  }

  onEnter(event: any): void {
    Logger.info(`CH:Dia: onEnter: ${JSON.stringify(event.target.value)}`)
    if (this.fsmState == ChatMachineStatesEnum.opActive) {
      if (event.target.value.length >= this.LV_MAX_INPUT) {
        if (this.messages[this.messages.length - 1].message[0] != this.WA_LV_MAX_INPUT_ERR_MSG) {
          this.messageBus.publishMessageToBus(this.createMsg(this.WA_LV_MAX_INPUT_ERR_MSG, "op", -1, false))

        }
        this.inputField.setValue(event.target.value.substring(0, this.LV_MAX_INPUT - 1))
        this.soundError.play()
      }

    } else {
      if (event.target.value.length >= this.WA_MAX_INPUT) {
        if (this.messages[this.messages.length - 1].message[0] != this.WA_LV_MAX_INPUT_ERR_MSG) {
          this.messageBus.publishMessageToBus(this.createMsg(this.WA_LV_MAX_INPUT_ERR_MSG, "xbot", -1, false))

        }
        this.inputField.setValue(event.target.value.substring(0, this.WA_MAX_INPUT - 1))
        this.soundError.play()
      }

    }
    this.localHistory.push(this.inputField.value)
    this.localHistoryCounter = 0
    this.sendMessage()
  }

  onPaste(event: ClipboardEvent): void {
    Logger.info(`CH:Dia: onPaste: ${JSON.stringify(event.clipboardData.getData('text'))}`)

    this.pastedInput = event.clipboardData.getData('text')

  }


  validateInputLengthOnBotClientOnly(input: string, shouldTrimBotInput: boolean): boolean {

    if (input.length <= this.WA_MAX_INPUT || !shouldTrimBotInput) {
      return true

    } else {
      return false

    }
  }

  validateInputLengthOnLivechatClientOnly(input: string): boolean {

    if (input.length <= this.LV_MAX_INPUT) {
      return true
    } else {
      return false
    }
  }


  /*
     regex pro podezrele znaky
     [@#$%^&*()";{}|<>/\\]
   
     nebo cz znaky
     https://stackoverflow.com/questions/9558015/use-czech-chars-in-regular-expression
   */
  validateInputOnBotClientOnly(input: string, shouldCheckInvalidInput: boolean): boolean {


    //Puvodni verze do 2.9.20
    //let matchAR = input.match(/[\[\]@#$%^&*()"/';{}|<>/\\]/g);

    //3.9 odstraneno: ()/"'
    if (shouldCheckInvalidInput) {
      let matchAR = input.match(/[\[\]@#$%^&*{}|<>\\]/g);
      let matchAR2 = input.match(/http:|https:|ftp:|ssh:|git:|file:|www/g)
      if (!matchAR && !matchAR2) {
        //nenalezno -> validni string pro odeslani na server
        Logger.info(`Valid characters in input. GO to server. Regex result: ${JSON.stringify(matchAR)}`)

        return true

      } else {
        Logger.warn(`Invalid characters in input. NO GO to server. Regex result: ${JSON.stringify(matchAR)}`)
        return false
      }
    } else {
      return true
    }

  }

  private findAndRemoveURLs(text) {
    //   //console.log('======================================================================DEBUG WRAP URL')

    let url_pattern = /(?:(?:https?|ftp):\/\/)?(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)(?:\.(?:[a-z\x{00a1}\-\x{ffff}0-9]+-?)*[a-z\x{00a1}\-\x{ffff}0-9]+)*(?:\.(?:[a-z\x{00a1}\-\x{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?/ig;


    let res2 = text.replace(url_pattern, '<odkaz>')

    // //console.log(`wrapURLs final Output: ${res2}`)
    return res2

  }

  validateInputOnLivechatOnly(input: string): boolean {

    //Puvodni verze do 2.9.20
    //let matchAR = input.match(/[\[\]@#$%^&*()"/';{}|<>/\\]/g);

    //3.9 odstraneno: ()/"'

    // let matchAR = input.match(/[\[\]@#$%^&*{}|<>\\]/g);
    let matchAR2 = input.match(/http:|https:|ftp:|ssh:|git:|file:|www/g)
    if (!matchAR2) {
      //nenalezno -> validni string pro odeslani na server
      Logger.info(`NO URL link in input. GO to server.`)

      return true

    } else {
      Logger.warn(`URL link in input. NO GO to server.`)
      return false
    }

  }

  async logRequestForOpToServer() {
    try {
      Logger.info(`CH:Dia:log request for operator...`)

      let payload: IPayloadToWatson

      payload = this.prepareRequestToWatson("OP_REQ", false)

      let res = await this.apiClient.makeQuestion(payload)
      Logger.info(`${moment().toISOString()}: CH:D:log request for operator result: ${JSON.stringify(res)}`)
    
    } catch (err) {
      Logger.error(`CH:D:log request for operator log upload failed: ${JSON.stringify(err)}`)

    }
  }

  async sendMessage(input?: string): Promise<Object> {
    let question: string
    let shouldAllowLongerInput = true
    let shouldCheckInvalidInput = true
    //input je bud z textu tlacitka



    if (input && input.length > 0) {
      question = input
      shouldCheckInvalidInput = false
    } else if (this.pastedInput.length >= this.WA_MAX_INPUT && this.shouldSendMessagesToBot()) {
      if (this.messages[this.messages.length - 1].message[0] != this.WA_LV_MAX_INPUT_ERR_MSG) {
        this.messageBus.publishMessageToBus(this.createMsg(this.WA_LV_MAX_INPUT_ERR_MSG, "xbot", -1, false))

      }
      this.inputField.setValue(this.inputField.value.substring(0, this.WA_MAX_INPUT - 1))
      //vynuluje se pasted input
      this.pastedInput = ''
      this.soundError.play()
      return

    } else if (this.pastedInput.length >= this.LV_MAX_INPUT) {
      if (this.messages[this.messages.length - 1].message[0] != this.WA_LV_MAX_INPUT_ERR_MSG) {
        this.messageBus.publishMessageToBus(this.createMsg(this.WA_LV_MAX_INPUT_ERR_MSG, "op", -1, false))
      }
      this.inputField.setValue(this.inputField.value.substring(0, this.LV_MAX_INPUT - 1))
      //vynuluje se pasted input
      this.pastedInput = ''
      this.soundError.play()
      return

    } else {
      //nebo z input field
      Logger.info(`CH:Dia:Checking message with input value: ${this.inputField.value}`)
      question = this.inputField.value
      shouldAllowLongerInput = false


    }

    //testovani regex pomoci vstupu
    //question = this.updateLinksInHTML(question)

    if (question && question.length > 0) {
      //console.log(`---------------------------------------------------------- DEbug: ${this.inputField.value.length}`)

      //vynuluje se pasted input
      this.pastedInput = ''

      //Emitace udalosti pro OKS pro timeout
      this.lastActivity.emit(moment().toISOString())


      if (question === 'versionUnitx') {

        //aktivace debug mode
        Logger.startDebug()

        this.handleResponseFromServer({
          "text": [version],
          "timestamp": ""
        }, question)
        this.inputField.setValue('')

        setTimeout(() => this.updateChangesAndScroll(), 50)
      } else {
        this.loading = true;

        if (this.shouldSendMessagesToBot()) {
          //do bota
          if (question && question.length > this.WA_MAX_INPUT && !shouldAllowLongerInput) {
            question = question.substring(0, this.WA_MAX_INPUT - 1)
          }

          if (this.validateInputOnBotClientOnly(question, shouldCheckInvalidInput)) {
            this.inputField.setValue('')
            setTimeout(() => this.updateChangesAndScroll(), 50)

            await this.sendMessageToBot(question)
          } else {
            Logger.warn(`BOT: Invalid input: ${question}. Invalid Regex check . Length: ${question.length} (should be max. ${this.WA_MAX_INPUT}. NO GO to BOT server....`)
            this.prepareRequestToWatson(question, true)

            this.handleResponseFromServer({
              "text": [this.WA_NOT_UNDERSTAND_TEXT],
              "timestamp": ""
            }, question)
          }


        } else {
          //poslat do LV
          if (question && question.length > this.LV_MAX_INPUT) {
            question = question.substring(0, this.LV_MAX_INPUT - 1)
          }
          if (this.validateInputOnLivechatOnly(question)) {
            this.inputField.setValue('')
            setTimeout(() => this.updateChangesAndScroll(), 50)

            await this.sendMessageToOp(question)
          } else {
            Logger.warn(`LV: Invalid input: ${question}.Either invalid Regex check or too long input. Length: ${question.length} (should be max. ${this.LV_MAX_INPUT}. NO GO to LV server....`)
            let question2 = this.findAndRemoveURLs(question)
            await this.sendMessageToOp(question2)
            this.handleErrorResponseFromXXX(IdOptionsEnum.op, this.LV_INVALID_USER_INPUT_MSG)
          }


        }

        this.loading = false

      }


    } else {
      //zatim nic
    }
    return true
  }

  async sendMessageToOp(input: string): Promise<Object> {
    try {
      Logger.info(`CH:Dia:sendMessageToOp with input value: ${input}`)

      //otazka uzivatele a jeji zobrazeni
      this.prepareRequestToWatson(input, true)

      //vystup/odpoved  se ziskava z long-polling read messages v LV klientovi
      let res = await this.livechatClient.sendMessageReq(input)
      Logger.info(`${moment().toISOString()}: CH:D:sendMessageToBot result: ${JSON.stringify(res)}`)
      return res
    } catch (err) {

    }
  }


  async sendMessageToBot(input: string, shouldHideQuestion?: boolean): Promise<Object> {
    Logger.info(`CH:Dia:sendMessageToBot with input value: ${input}`)

    let payload: IPayloadToWatson
    if (shouldHideQuestion) {
      payload = this.prepareRequestToWatson(input, false)
    } else {

      payload = this.prepareRequestToWatson(input, true)
    }

    //zde se i pokazde vyzkousi stav chatbota
    let res = await this.apiClient.makeQuestion(payload)
    Logger.info(`${moment().toISOString()}: CH:D:sendMessageToBot result: ${JSON.stringify(res)}`)
    // //console.log(`D1 --------------------`)
    ////console.log(res)
    if (res === 'relogin') {
      //volam znovu v pripade ze byla predtim chyba
      this.sendMessageToBot(input, true)
    } else if (res === 'relogin-err') {
      this.handleErrorResponseFromXXX(IdOptionsEnum.xbot, this.WA_ERROR_TEXT)

      this.chatStateMachine.updateState({ type: ChatMachineEventEnum.BOT_OFFLINE, value: {} })

    } else if (res === 'unexpected-err') {
      this.handleErrorResponseFromXXX(IdOptionsEnum.xbot, this.WA_ERROR_TEXT)

      this.chatStateMachine.updateState({ type: ChatMachineEventEnum.BOT_OFFLINE, value: {} })

    } else {
      //Uspesna odpoved from RB NLP
      this.handleResponseFromServer(res, input)
      this.chatStateMachine.updateState({ type: ChatMachineEventEnum.BOT_ONLINE, value: {} })

    }

    //Kratka prodleva aby se pripadne zpropagoval stav o dostupnosti chatbota
    setTimeout(() => this.checkShouldEnableChatButton(), 200)

    return res

  }

  /**
   * Po kazde odeslane zprave kontroluji zda mam zobrazit LV tlacitko
   * V pripade ze je CHAT stav error/busy a je LV online rovnou nabizim tlacitko po kazde otazce
   */

  async checkShouldEnableChatButton() {
    let shouldDisplayChatButton = false
    //console.log("=------------------------------- checkShouldEnableChatButton")

    if (this.fsmState == ChatMachineStatesEnum.botActiveNoOp || this.fsmState == ChatMachineStatesEnum.botActiveOpDisabled) {
      //neni co aktualizovat

    } else if (this.fsmState == ChatMachineStatesEnum.botErrorOpOffshift) {
      //neni co aktualizovat

    } else if (this.fsmState == ChatMachineStatesEnum.opBusyBotError) {
      //nedostupny LV kontroluji zda jiz dostupny
      let status: ChatAvailabilityStateEnum = await this.livechatClient.setOptionsAndCheckAvailabilityStatus(this.apikey2, true)

      //a nasledne zobrazuji
      if (status == ChatAvailabilityStateEnum.ONLINE) {
        //pokud je bot v ERR, tak rovnou zobrazit LV tlacitko
        this.chatStateMachine.updateState({ type: ChatMachineEventEnum.BOT_ONLINE_OFFER_OP, value: {} })
      }
    } else if (
      this.fsmState == ChatMachineStatesEnum.opErrorBotError
      || this.fsmState == ChatMachineStatesEnum.botActiveOpError) {

      //nedostupny LV kontroluji zda jiz dostupny
      let status: ChatAvailabilityStateEnum = await this.livechatClient.setOptionsAndCheckAvailabilityStatus(this.apikey2, true)

      //a nasledne zobrazuji
      if (status == ChatAvailabilityStateEnum.ONLINE) {
        //pokud je bot v ERR, tak rovnou zobrazit LV tlacitko
        this.chatStateMachine.updateState({ type: ChatMachineEventEnum.BOT_ONLINE_OFFER_OP, value: {} })


      } else {
        //Zustava stale v puvodnim/nedostupnem stav
      }

    } else {
      //pro vsechny ostatni stavy je dostupny: pocitam pocty otazek
      if (this.fsmState == ChatMachineStatesEnum.botActiveAndWaitingToStartOfferOp || this.fsmState == ChatMachineStatesEnum.botActiveOpBusy) {

        // console.log('DEBUG )
        if (this.singleAnswersCounter >= 2) {

          //zobrazit LV button po druhe otazke pokud byla odpovezna vzdy jen jednou odpovedi
          shouldDisplayChatButton = true

        } else if (this.answersCounter >= 3) {
          //od 3 dale zobrazovat vzdy
          shouldDisplayChatButton = true

        } else {
          shouldDisplayChatButton = false

        }


        if (shouldDisplayChatButton) {
          //JESTE predtim ZKONTROLOVAT aktualni DOSTUPNOST LV SLUZBY (SPECIALNE BUSY)
          //Kontroluje se ale pouze 1x, Potom co se objevilo tlacitko, tak se jiz nedela

          let status: ChatAvailabilityStateEnum = await this.livechatClient.setOptionsAndCheckAvailabilityStatus(this.apikey2, true)

          if (status == ChatAvailabilityStateEnum.ONLINE) {
            let stateTemp = this.chatStateMachine.getState()

            if (stateTemp == ChatMachineStatesEnum.botActiveAndWaitingToStartOfferOp) {
              //pouze v pripade  ze je jeste stale ve stavu bez tlacitka
              this.chatStateMachine.updateState({ type: ChatMachineEventEnum.BOT_ONLINE_OFFER_OP, value: {} })
            }

          }




        }
      } else {

        shouldDisplayChatButton = false
      }
    }
  }


  updateScroll() {
    //  Logger.info(`${moment().toISOString()} Running scroll start ...`)
    try {
      const el: HTMLElement = this.container.nativeElement;
      if (el) {

        if (this.isIe) {
          el.scrollTop = 100000
          //   Logger.info(`${moment().toISOString()} IE2: Running scroll end... before input field reset`)

          //   Logger.info(`${moment().toISOString()} IE2: Running scroll end... after input field reset`)

        } else {
          //zruseno 11.6. oks "blokuje" jednoduchy scrolling
          // el.scrollBy({left: 0, top: 100000, behavior: true ? 'auto' : 'smooth' });
          el.scrollTo({ left: 0, top: 100000, behavior: true ? 'auto' : 'smooth' });
          // el.scrollTo(0, 100000);
          //   Logger.info(`${moment().toISOString()} Running scroll end... before input field reset`)

          //   Logger.info(`${moment().toISOString()} Running scroll end... after input field reset`)
        }
      } else {
        //  Logger.error('ERR running scroll...')
      }
    } catch (err) {
      Logger.error('Unexpected ERR running scroll...(probably hidden)')
    }

  }



  ngOnDestroy() {
    this.machineEventSub.unsubscribe();
    this.messageSubscription.unsubscribe()
    this.oksHeartbeatSubscription.unsubscribe()
    this.livechatClient.endChatReq(true)
  }

  /*
    LIVECHAT sluzby a funkce
   
 
  */


  controlChatButton(mode: number): void {
    // //console.log(`CONTROL chat button: ${mode}`)
    if (mode == 0) {
      Logger.info(`LV start chat Button selected. History will be sent..`)
      //Musi to byt zde kvuli predani predchozich zprav (nelze presunout do FSM)

      this.chatStateMachine.updateState({ type: ChatMachineEventEnum.OP_WAITING_FOR_GDPR_CONSENT, value: {} })
    } else if (mode == 2) {
      //Muze nastat pri dlouhem cekani na OP nebo v prubehu aktivniho chatu s OP

      let stateTemp = this.chatStateMachine.getState()

      if (stateTemp == ChatMachineStatesEnum.opWaitingForOp1 || stateTemp == ChatMachineStatesEnum.opWaitingForOp2) {

        Logger.info(`----------------------------------------------------------> LV END Button selected during waiting on OP. -> go to end (no feedback)`)
        this.chatStateMachine.updateState({ type: ChatMachineEventEnum.OP_ENDED_BY_USER, value: {} })
      } else if (stateTemp == ChatMachineStatesEnum.opActive) {
        Logger.info(`-------------------------------------------------------> LV END Button selected during chat with OP. -> go to feedback/end`)
        this.chatStateMachine.updateState({ type: ChatMachineEventEnum.OP_FEEDBACK, value: {} })
      }
    }

  }

  async onFeedbackChatButton(mode: number): Promise<void> {
    Logger.info(`LV FEEDBACKU Button selected in mode: ${mode}`)
    if (mode != -1) {
      await this.livechatClient.sendChatEvaluationReq(mode)
    }
    this.chatStateMachine.updateState({ type: ChatMachineEventEnum.OP_FEEDBACK_DONE, value: {} })

  }

  onWaitForOpChatButton(mode: boolean): void {
    Logger.info(`LV WAIT for OP Button selected in mode: ${mode}`)
    if (mode) {
      //wait for oP

      Logger.info(`LV still WANT wait for OP Button selected ..`)
      this.livechatClient.createNewChat(1)
      this.chatStateMachine.updateState({ type: ChatMachineEventEnum.OP_CONTINUE_TO_WAIT, value: { waitForOpCounter: 1 } })


    } else {
      //cancel waiting - TBD: co s countereem, staci 0 ???
      this.chatStateMachine.updateState({ type: ChatMachineEventEnum.OP_ENDED_BY_USER, value: { waitForOpCounter: 0 } })

    }
  }


  onConsentButton(mode: boolean): void {
    // //console.log(`LV Consent Button selected in mode: ${mode}`)


    if (mode) {
      Logger.info(`LV still want to go with PII processing ..`)
      this.livechatClient.createNewChat(0, this.messages)
      this.chatStateMachine.updateState({ type: ChatMachineEventEnum.OP_WAITING_FOR_OP_1, value: {} })
    } else {

      Logger.info(`----------------------------------------------------------> LV END Button selected during waiting on OP. -> go to end (no feedback)`)
      this.chatStateMachine.updateState({ type: ChatMachineEventEnum.OP_ENDED_BY_USER, value: {} })
    }

  }




}
